<div class="card mb-4">
    <div class="card-header">
        <h4>Production Form</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="productionForm" (ngSubmit)="onSubmit()">
          


            <div class="row">
                <div class="col form-group mb-3">
                    <label for="refNo">Ref No</label>
                    <input type="text" id="refNo" formControlName="refNo" class="form-control" />
                </div>

                <div class="col form-group mb-3">
                    <label for="poNumber">PO Number</label>
                    <input type="text" id="poNumber" formControlName="poNumber" class="form-control" />
                </div>

            </div>


            <div class="row">
                <div class="col form-group mb-3">
                    <label for="clientName">Client Name</label>
                    <input type="text" id="clientName" formControlName="clientName" class="form-control" />
                </div>

                <div class="col form-group mb-3">
                    <label for="jobName">Job Name</label>
                    <input type="text" id="jobName" formControlName="jobName" class="form-control" />
                </div>

                <div class="col form-group mb-3">
                    <label for="orderKgs">Order Kgs</label>
                    <input type="number" id="orderKgs" formControlName="orderKgs" class="form-control" />
                </div>
            </div>



            <ul class="nav nav-tabs">
                <!-- <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'printing'" (click)="onTabChange('printing')">Printing</a>
                </li> -->
                <!-- Add other tabs as necessary -->
               

                <!-- <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'lamination'"
                        (click)="onTabChange('lamination')">Lamination</a>
                </li> -->

                <!-- when tab is active -->
                <!-- <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'printing'" (click)="onTabChange('printing')">
                      Printing
                      <span *ngIf="tabActive === 'printing'" class="badge bg-success">{{ tabCompletion.printing }}%</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'lamination'" (click)="onTabChange('lamination')">
                      Lamination
                      <span *ngIf="tabActive === 'lamination'" class="badge bg-success">{{ tabCompletion.lamination }}%</span>
                    </a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'printing'" (click)="onTabChange('printing')">
                      Printing
                      <span class="badge bg-success">{{ tabCompletion.printing }}%</span> <!-- Always visible -->
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'lamination'" (click)="onTabChange('lamination')">
                      Lamination
                      <span class="badge bg-success">{{ tabCompletion.lamination }}%</span> <!-- Always visible -->
                    </a>
                </li>
            </ul>

            <div *ngIf="tabActive === 'printing'">
            <div class="form-group mb-3 process">
                <label class="process-label">Select Processes</label>
              
                <!--  -->
                <!--  -->

                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="addProduction" formControlName="addProduction"
                        (change)="onProcessChange('addProduction')">
                    <label class="form-check-label" for="addProduction">Add Rolls</label>
                </div>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="inking" formControlName="inking"
                        (change)="onProcessChange('inking')">
                       
                    <label class="form-check-label" for="inking">Add Ink</label>
                </div>
            </div>

           

          
            <div *ngIf="productionForm.get('addProduction').value">


                <h5 class="text-left font-bold font-up danger-text">Printing Production Info</h5>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="form-label">Material</label>
                           

                            <select id="materialCategory" formControlName="materialCategory" class="form-select">
                                <option value="CLEAR BOPP ">CLEAR BOPP </option>
                                <option value="MET BOPP">MET BOPP</option>
                                <option value="ADDITIVES">ADDITIVES</option>
                                <option value="C BOPP">C BOPP</option>
                                <option value="CLEAR CPP">CLEAR CPP</option>
                                <option value="PEARLIZED BOPP">PEARLIZED BOPP</option>
                                <option value="PET">PET</option>
                                <option value="PET G">PET G</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="matSpecifications">Material Specifications</label>
                           

                            <select id="matSpecifications" formControlName="matSpecifications" class="form-control">
                                <option *ngFor="let specification of matSpecifications" [value]="specification">
                                    {{specification}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="matRollNo">Mat Roll No</label>
                           

                              <select id="matRollNo" formControlName="matRollNo" class="form-select" required>
                                <option value="" disabled selected>Select Mat Roll No</option>
                                <option *ngFor="let roll of filteredInventoryList" [value]="roll.rollNo">{{ roll.rollNo }}</option>
                              </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="prodWeight">Weight Kgs</label>
                            <input type="text" id="prodWeight" formControlName="prodWeight" class="form-control" />
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="prodReturn">Return Kgs</label>
                            <input type="text" id="prodReturn" formControlName="prodReturn" class="form-control" />
                        </div>
                    </div>

                   
                    <div class="col-md-2 hidden">
                        <div class="form-group">
                          <label for="availTime">Available Time</label>
                          <input type="text" formControlName="availTime" id="availTime" class="form-control" readonly />
                        </div>
                      </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="prodOutputRollNo">Output Roll No</label>
                            <input type="text" id="prodOutputRollNo" formControlName="prodOutputRollNo"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="prodOutputKg">Output Kgs</label>
                            <input type="text" id="prodOutputKg" formControlName="prodOutputKg" class="form-control" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="prodWaste">Waste Kgs</label>
                            <input type="text" id="prodWaste" formControlName="prodWaste" class="form-control" />
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="prodFlag">Flag</label>
                            <input type="text" id="prodFlag" formControlName="prodFlag" class="form-control" />
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                <div class="form-group mb-3 ">

                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="rolls" formControlName="rolls"
                            (change)="onProcessChangeRolls('rolls')">
                        <label class="form-check-label" for="rolls">Add Rolls Detail</label>
                    </div>
                </div>

                <div *ngIf="productionForm.get('rolls').value">
                    <div class="row mb-3">
                        <div class="col-3 col form-group mb-3">
                          
                                <label class="">DownTime</label>
                                <select class="form-select" formControlName="downTime" id="downTime" required>
                                    <option value="" disabled selected>Select DownTime</option>
                                    <option value="Breakdown">Breakdown</option>
                                    <option value="JCO">JCO</option>
                                    <option value="Cylinder Clean">Cylinder Clean</option>
                                    <option value="D/B Change">D/B Change</option>
                                    <option value="Splice Fail">Splice Fail</option>
                                    <option value="Power Fail">Power Fail</option>
                                    <option value="AW Approval">AW Approval</option>
                                    <option value="Shade Approval">Shade Approval</option>
                                    <option value="No Operator">No Operator</option>
                                    <option value="Maintenance">Maintenance</option>
                                    <option value="Material Shortage">Material Shortage</option>
                                </select>
                           
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="downTimeTime">Time (Minutes)</label>
                             
                                    <select formControlName="downTimeTime" class="form-control">
                                        <option *ngFor="let time of timeIntervals" [value]="time">{{ time }}</option>
                                      </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="downTimeRemarks">DownTime Remarks</label>
                                <input type="text" id="downTimeRemarks" formControlName="downTimeRemarks"
                                    class="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
                </div>




                <!-- table  -->
                <button type="button" class="btn btn-success offset-md-10" (click)="saveProductionData()">Save</button>

                <!-- Table to show saved data -->
                <div *ngIf="savedProductionData.length > 0" class="mt-3">
                    <h6>Saved Production Data</h6>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Material Specification</th>
                                <th>Mat Roll No</th>
                                <th>Flag</th>
                                <th>Weight (Kgs)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of savedProductionData">
                                <td>{{ data.matSpecifications }}</td>
                                <td>{{ data.matRollNo }}</td>
                                <td>{{ data.prodFlag }}</td>
                                <td>{{ data.prodWeight }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>

        
            <div *ngIf="productionForm.get('inking').value">

                <h5 class="text-left font-bold font-up danger-text">Add Ink Details</h5>
                <div class="row mb-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="inkName">Ink Name</label>
                          
                            <select class="form-select" formControlName="inkName" required>
                                <option value="" disabled selected>Select Ink Name</option>
                                <option value="INK PEONY">INK PEONY</option>
                                <option value="INK ALPINE">INK ALPINE</option>
                                <option value="VIOLET">VIOLET</option>
                                <option value="MAGENTA">MAGENTA</option>
                                <option value="INK BOPP">INK BOPP</option>
                                <option value="INK POLY">INK POLY</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="inkColor">Ink Color</label>
                          
                            <select class="form-select" formControlName="inkColor" required>
                                <option value="" disabled selected>Select Ink Color</option>
                                <option value="CYAN">CYAN</option>
                                <option value="RED">RED</option>
                                <option value="BLACK">BLACK</option>
                                <option value="BLUE">BLUE</option>
                                <option value="GREEN">GREEN</option>
                                <option value="GOLD">GOLD</option>
                                <option value="MAGETA">MAGETA</option>
                                <option value="ORANGE">ORANGE</option>
                                <option value="MEDIUM">MEDIUM</option>
                                <option value="REFLEX">REFLEX</option>
                                <option value="VIOLET">VIOLET</option>
                                <option value="WHITE">WHITE</option>
                                <option value="VANISH">VANISH</option>
                                <option value="BROWN">BROWN</option>
                                <option value="YELLOW">YELLOW</option>
                                <option value="OPV">OPV</option>
                                <option value="HARDNER">HARDNER</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="inkType">Ink Type</label>
                          
                            <select class="form-select" formControlName="inkType" required>
                                <option value="" disabled selected>Select Ink Type</option>
                                <option value="Mixed">Mixed</option>
                                <option value="Fresh">Fresh</option>
                               
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="issue">Issue</label>
                            <input type="text" id="issue" formControlName="issue" class="form-control" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="inkReturn">Return(Kgs)</label>
                            <input type="text" id="inkReturn" formControlName="inkReturn" class="form-control" />
                        </div>
                    </div>
                  





                    <div class="form-group mb-3 breakdown-button">

                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="breakdown" formControlName="breakdown"
                                (change)="onProcessChangeBreakdown('breakdown')">
                            <label class="form-check-label" for="breakdown">Capture Breakdown</label>
                        </div>
                    </div>

                  
                    <div *ngIf="productionForm.get('breakdown').value">
                        <div class="row mb-3">
                            <div class="col-3 col form-group mb-3">
                              
                                    <label class="">DownTime</label>
                                    <select class="form-select" formControlName="downTime" id="downTime" required>
                                        <option value="" disabled selected>Select DownTime</option>
                                        <option value="Breakdown">Breakdown</option>
                                        <option value="JCO">JCO</option>
                                        <option value="Cylinder Clean">Cylinder Clean</option>
                                        <option value="D/B Change">D/B Change</option>
                                        <option value="Splice Fail">Splice Fail</option>
                                        <option value="Power Fail">Power Fail</option>
                                        <option value="AW Approval">AW Approval</option>
                                        <option value="Shade Approval">Shade Approval</option>
                                        <option value="No Operator">No Operator</option>
                                        <option value="Maintenance">Maintenance</option>
                                        <option value="Material Shortage">Material Shortage</option>
                                    </select>
                               
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="downTimeTime">Time (Minutes)</label>
                                 
                                        <select formControlName="downTimeTime" class="form-control">
                                            <option *ngFor="let time of timeIntervals" [value]="time">{{ time }}</option>
                                          </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="downTimeRemarks">DownTime Remarks</label>
                                    <input type="text" id="downTimeRemarks" formControlName="downTimeRemarks"
                                        class="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Save Ink Details Button -->
<button type="button" class="btn btn-success offset-md-10" (click)="saveInkData()">Save Ink Details</button>

<!-- Table to show saved ink data -->
<div *ngIf="savedInkData.length > 0" class="mt-3">
    <h6>Saved Ink Data</h6>
    <table class="table table-striped">
        <thead>
            <tr>
                <th>Ink Name</th>
                <th>Ink Color</th>
                <th>Ink Type</th>
                <th>Issue</th>
                <th>Return (Kgs)</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of savedInkData">
                <td>{{ data.inkName }}</td>
                <td>{{ data.inkColor }}</td>
                <td>{{ data.inkType }}</td>
                <td>{{ data.issue }}</td>
                <td>{{ data.inkReturn }}</td>
            </tr>
        </tbody>
    </table>
</div>

            </div>
            </div>

            <div *ngIf="tabActive === 'lamination'">
                <h5 class="text-left font-bold font-up danger-text">Lamination Details</h5>
                <div class="row mb-3">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="laminationMachine">Lamination Machine</label>
                            <!-- <select class="form-select" formControlName="laminationMachine" required> -->
                                <select class="form-select" formControlName="laminationMachine" >
                                <option value="" disabled selected>Select Lamination Machine</option>
                                <option value="Machine 1">Machine 1</option>
                                <option value="Machine 2">Machine 2</option>
                                <option value="Machine 3">Machine 3</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="laminationFilm">Lamination Film</label>
                            <select class="form-select" formControlName="laminationFilm" >
                                <option value="" disabled selected>Select Lamination Film</option>
                                <option value="Film A">Film A</option>
                                <option value="Film B">Film B</option>
                                <option value="Film C">Film C</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="laminationOperator">Lamination Operator</label>
                            <input type="text" id="laminationOperator" formControlName="laminationOperator"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>

            
            

           
            <button type="submit" class="btn btn-primary mt-3"  [disabled]="!productionForm.valid">Submit</button>

           
        </form>
    </div>
</div>




















